import { Component, Input } from '@angular/core';
import { Params, RouterLinkWithHref } from '@angular/router';

import { LoadingSpinnerComponent } from '@Components';

@Component({
  selector: 'app-uptakes-data',
  imports: [LoadingSpinnerComponent, RouterLinkWithHref],
  templateUrl: './uptakes-data.component.html',
  styleUrl: './uptakes-data.component.css',
})
export class UptakesDataComponent {
  @Input() data: number | null = null;
  @Input() isLoading = true;
  @Input() isDataNotFound = false;
  @Input() title = '';
  @Input() queryParams: Params = {};
}
